(function () {
  function initDoncasterLandingTracking() {
    var roots = document.querySelectorAll('[data-db-landing]');
    roots.forEach(function (root) {
      if (root.getAttribute('data-db-tracking-bound') === 'true') return;
      root.setAttribute('data-db-tracking-bound', 'true');
      var trackedTargets = root.querySelectorAll('[data-db-event]');
      root.setAttribute('data-db-event-count', String(trackedTargets.length));
      trackedTargets.forEach(function (target) {
        target.addEventListener('click', function () {
          var eventName = target.getAttribute('data-db-event');
          root.setAttribute('data-db-last-event', eventName);
          var payload = {
            event: eventName,
            campaign_store: 'doncaster',
            landing_page_id: 'doncaster-repair-voucher'
          };
          window.drBoomAnalyticsQueue = window.drBoomAnalyticsQueue || [];
          window.drBoomAnalyticsQueue.push(payload);
          if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDoncasterLandingTracking);
  } else {
    initDoncasterLandingTracking();
  }
function resetInitialScroll(){if(window.location.hash)return;if('scrollRestoration' in window.history)window.history.scrollRestoration='manual';window.scrollTo(0,0);window.requestAnimationFrame(function(){window.scrollTo(0,0);});}window.addEventListener('pageshow',resetInitialScroll);resetInitialScroll();}());
